import i18next from "i18next";
import i18nResource from "../i18n";
import Config from "../config";
import { languageOptions } from "./constants/languageList";
import * as ReactI18next from 'react-i18next';
import { initReactI18next } from 'react-i18next';

i18next.use(initReactI18next).init({
  fallbackLng: Config.LANGUAGE.DEFAULT,
  supportedLngs: languageOptions.map((item) => item.value),
  // debug: true,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources: i18nResource,
});
